export default "__VITE_ASSET__DlkCa25M__"